import { z } from 'zod';
import { HostInitSchema, MoneySchema } from '@resto/contracts';

/** Сообщения хост → виджет. */
export const HostToWidgetMessageSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('host:init'), payload: HostInitSchema }),
  z.object({
    type: z.literal('host:theme'),
    payload: z.object({
      mode: z.enum(['light', 'dark']),
      tokens: z.record(z.string(), z.string()).default({}),
    }),
  }),
  z.object({
    type: z.literal('host:config'),
    payload: z.object({ config: z.record(z.string(), z.unknown()) }),
  }),
  z.object({
    type: z.literal('host:visibility'),
    payload: z.object({ visible: z.boolean() }),
  }),
  z.object({ type: z.literal('host:close') }),
  z.object({
    type: z.literal('host:token'),
    payload: z.object({
      guestToken: z.string().min(1),
      expiresAt: z.string().min(1),
    }),
  }),
]);
export type HostToWidgetMessage = z.infer<typeof HostToWidgetMessageSchema>;

/** Сообщения виджет → хост. */
export const WidgetToHostMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('widget:ready'),
    payload: z.object({ widgetId: z.string(), version: z.string() }),
  }),
  z.object({
    type: z.literal('widget:resize'),
    payload: z.object({ height: z.number().int().positive().max(20000) }),
  }),
  z.object({
    type: z.literal('widget:toast'),
    payload: z.object({
      message: z.string().min(1).max(500),
      level: z.enum(['info', 'success', 'error']).default('info'),
    }),
  }),
  z.object({
    type: z.literal('widget:navigate'),
    payload: z.object({ url: z.string().url(), external: z.boolean().default(false) }),
  }),
  z.object({
    type: z.literal('widget:payment'),
    payload: z.object({
      orderId: z.string().min(1),
      amount: MoneySchema,
      /** Платёж уже создан виджетом: нативный хост откроет готовую ссылку. */
      paymentId: z.string().min(1).optional(),
      confirmationUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    type: z.literal('widget:error'),
    payload: z.object({ code: z.string().min(1), message: z.string().min(1) }),
  }),
  z.object({
    type: z.literal('widget:auth-required'),
    payload: z.object({
      reason: z.string().max(300).default('guest_session_expired'),
    }),
  }),
]);
export type WidgetToHostMessage = z.infer<typeof WidgetToHostMessageSchema>;

export type HostToWidgetType = HostToWidgetMessage['type'];
export type WidgetToHostType = WidgetToHostMessage['type'];
